export default __webpack_public_path__ + "static/media/flag-british-virgin-islands.6ff28e67.svg";